export type Grouping = 'daily' | 'weekly'

interface GroupingSelectorProps {
  value: Grouping
  onChange: (grouping: Grouping) => void
}

export function GroupingSelector({ value, onChange }: GroupingSelectorProps) {
  return (
    <div className="flex rounded-lg border border-gray-300 overflow-hidden">
      <button
        onClick={() => onChange('daily')}
        className={`px-3 py-2 text-sm font-medium transition-colors ${
          value === 'daily'
            ? 'bg-primary-100 text-primary-700'
            : 'bg-white text-gray-600 hover:bg-gray-50'
        }`}
      >
        Daily
      </button>
      <button
        onClick={() => onChange('weekly')}
        className={`px-3 py-2 text-sm font-medium border-l border-gray-300 transition-colors ${
          value === 'weekly'
            ? 'bg-primary-100 text-primary-700'
            : 'bg-white text-gray-600 hover:bg-gray-50'
        }`}
      >
        Weekly
      </button>
    </div>
  )
}
